import React from 'react'
import { Label, Icon, Popup } from 'semantic-ui-react'
import utils from '../../../../utils'

export default class BlacklistInfo extends React.PureComponent {
  render() {
    const { order } = this.props

    if (!order.blacklist) return null

    const callableDriverTel = utils.helpers.convertToLocalPhoneNumber(order.blacklist.phone)

    return (
      <React.Fragment>
        <hr style={{ margin: '3px 0px 0px 0px' }} />
        <div>
          <Popup
            hideOnScroll
            style={{ maxWidth: 400 }}
            trigger={
              <Label color="red" style={{ margin: '3px 0px', cursor: 'pointer' }}>
                <Icon name="ban" />
                Existed in Blacklist
              </Label>
            }
            on="click"
            position="top center"
          >
            <div>
              <div>
                Tel:
                <a href={utils.helpers.convertToCallableLink(callableDriverTel)}>
                  <Label style={{ marginLeft: 5 }}>{order.blacklist.phone || 'Unknown'}</Label>
                </a>
              </div>
              <div style={{ marginTop: 5 }}>
                UUID: <Label>{order.blacklist.uuid || 'Unknown'}</Label>
              </div>
              {order.blacklist.reason && (
                <div style={{ marginTop: 5 }}>Reason: {order.blacklist.reason || 'No Reason'}</div>
              )}
            </div>
          </Popup>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/BlacklistInfo.js